import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class SuSabitBilgiGetAPI extends BaseAPI {
    constructor() {
        const baseUrl = environment.API_URL + "SuSabitBilgiGet";
        super(baseUrl);
    }
    getSuSabitBilgiGet() {
        return this.get();
    }
}
export default new SuSabitBilgiGetAPI();
